import { render, staticRenderFns } from "./ContactConfirmation.html?vue&type=template&id=dc843a48&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./ContactConfirmation.scss?vue&type=style&index=0&id=dc843a48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc843a48",
  null
  
)

export default component.exports